import { setActiveCustomerTab, setHeader, setIsLoggedIn, setUserDetails } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import { getData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import { routes } from '@/utils/routes/routes';
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router';
import { routePrefix } from '@/utils/routes/routes';
import { toast } from 'react-toastify';
import { MdClose, MdDelete, MdMenu, MdPersonAdd, MdSearch } from 'react-icons/md';
import { TbHeart, TbMapPin, TbShoppingCart } from 'react-icons/tb';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { removeCartItem } from '@/core/redux/cartSlice';
import { emptycart, headerLogo } from '@/utils/imagepath';

const Header3 = ({ themeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const [sticky, setSticky] = useState('');
  const fixedheader = `home-three-header header ${sticky}`;
  const headerData = useSelector((state: RootState) => state.common.header);
  const isLoggedIn = useSelector((state: RootState) => state.common.isLoading);
  const [visibleRight, setVisibleRight] = useState(false);
  const cartItems = useSelector((state: RootState) => state.cart.cartItems);
  const formRef = useRef<HTMLFormElement>(null);
  const [value, setValue] = useState<string>('');
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(
    null
  );
  
  const navigate = useNavigate();

  const dataCount = useSelector(
    (state: RootState) => state.common.wishListCount
  );

  const total = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const isSticky = () => {
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 100 ? 'fixed' : '';
    setSticky(stickyClass);
  };
  const dispatch = useDispatch();

  const getHeader = async () => {
    try {
      const response = await getData(end_points.headers.url);
      dispatch(setHeader(response?.data?.data));
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getHeader();
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', isSticky);
    return () => {
      window.removeEventListener('scroll', isSticky);
    };
  }, []);

  const handleCheckout = () => {
    if (isLoggedIn) {
      if (cartItems?.length == 0) {
        toast.warn('Please add some products to your cart');
      } else {
        setVisibleRight(false);
        navigate(routes.checkout);
      }
    } else {
      toast.warn('Please login to Checkout');
    }
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    setValue(inputValue);

    if (searchTimeout) clearTimeout(searchTimeout);

    const timeout = setTimeout(async () => {
      if (inputValue.trim() !== '') {
        navigate(`${routePrefix}/search/${inputValue}`);
      }
    }, 1000);

    setSearchTimeout(timeout);
  };

  var sidebar = document.getElementById("sidebar");
  var overlay = document.getElementById("overlay");

  const sidebarOpen = () => {
    sidebar?.classList.add("active");
    overlay?.classList.add("active");
  };

  const sidebarClose = () => {
    sidebar?.classList.remove("active");
    overlay?.classList.remove("active");
  };

  return (
    <>
      {themeData && (
        <style type="text/css">
          {` 
            :root {
              --primary-color: #${themeData?.theme_3?.home?.header?.primary_color};
              --secondary-color: #${themeData?.theme_3?.home?.header?.secondary_color};
              --nav-color: #${themeData?.theme_3?.home?.header?.nav?.menu_font_color};
              --nav-color-hover: #${themeData?.theme_3?.home?.header?.nav?.menu_font_color_hover};
              --nav-color-active: #${themeData?.theme_3?.home?.header?.nav?.menu_font_color_active};
              --btn1-color:#${themeData?.theme_3?.home?.header?.btn_group?.btn1?.color};
              --btn1-border_color:#${themeData?.theme_3?.home?.header?.btn_group?.btn1?.border_color};
              --btn1-bg_color:#${themeData?.theme_3?.home?.header?.btn_group?.btn1?.bg_color};
              --btn2-color:#${themeData?.theme_3?.home?.header?.btn_group?.btn2?.color};
              --btn2-border_color:#${themeData?.theme_3?.home?.header?.btn_group?.btn2?.border_color};
              --btn2-bg_color:#${themeData?.theme_3?.home?.header?.btn_group?.btn2?.bg_color};
          }
          `}
        </style>
      )}
      <header
        className={fixedheader}
        style={{
          background: `#${themeData?.theme_3?.home?.header?.nav?.bg_color}`,
        }}
      >
        <div className="header-top">
          <div className="container-fluid">
            <div className="row header-nav">
              <div className="col-md-auto col-sm-12">
                <div className="logo">
                  <span id="sidebarCollapse" className="d-block d-md-none" onClick={sidebarOpen}>
                    <MdMenu />
                  </span>
                  <a href="/" className="">
                    <img
                      id="site_logo"
                      src={headerData?.logo}
                      alt=""
                    />
                  </a>
                  <span className="mob-user hidden-md dropdown d-block d-md-none">
                    <a
                      className="more-items"
                      data-bs-toggle="dropdown"
                      href="#"
                    />
                    <ul
                      role="menu"
                      className="dropdown-menu"
                      aria-labelledby="drop1"
                    >
                      {!isLoggedIn && (
                        <li>
                          <Link to={routes.login}>Login</Link>
                        </li>
                      )}
                    </ul>
                  </span>
                </div>
              </div>
              <div className="col-md col-sm-12">
                <div className="d-none d-md-flex align-items-center h-100">
                  <ul className="header-link">
                    {headerData.headers.map((header: any) => (
                      <li className="menu-hover" key={header.id}>
                        <Link
                          to={`${header?.slug == '#' ? '#' : routePrefix + '/' + header?.slug}`}
                        >
                          {header?.title}
                        </Link>
                      </li>
                    ))}
                    {headerData?.table_management_enabled === '1' && (
                      <li>
                        <Link to={routes.tableBooking}>Request a Table</Link>
                      </li>
                    )}
                    <li>
                      <Link to={routes.pricing}>Pricing</Link>
                    </li>
                  </ul>
                  {/* Search */}
                  <div className="col-md col-md-4 ml-20">
                    <form
                      ref={formRef}
                      className="header-search d-flex flex-column position-relative"
                      style={{ flex: 1, maxWidth: '500px', margin: '0 auto' }}
                      onSubmit={(e) => {
                        e.preventDefault();
                        // optional: submit logic
                      }}
                    >
                      <div className="header-search-container2 d-flex w-100">
                        <input
                          id="search"
                          type="text"
                          placeholder="Search products..."
                          name="search"
                          className="form-control"
                          value={value}
                          onChange={handleSearch}
                        />
                        <button
                          className="btn-search"
                          type="submit"
                          style={{
                            backgroundColor: '#007bff',
                            color: '#fff',
                            borderTopRightRadius: '4px',
                            borderBottomRightRadius: '4px',
                          }}
                        >
                          <MdSearch size={20} />
                        </button>
                      </div>
                    </form>
                  </div>
                  <ul className="header-link-right">
                    {!isLoggedIn ? (
                      <li>
                        <Link to={routes.login}>Login</Link>
                      </li>
                    ) : (
                      <li className="user-menu position-relative">
                        <MdPersonAdd size={22} />
                        <ul className="user-dropdown-menu">
                          <li>
                            <Link
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('account-details'));
                              }}
                            >
                              My Account
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('orders'));
                              }}
                            >
                              Order History
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={routes.customerDashboard}
                              onClick={() => {
                                dispatch(setActiveCustomerTab('address'));
                              }}
                            >
                              Addresses
                            </Link>
                          </li>
                          <li>
                            <Link
                              to={''}
                              onClick={() => {
                                localStorage.clear();
                                dispatch(setUserDetails({}));
                                dispatch(setIsLoggedIn(false));
                                navigate(routes.login);
                              }}
                            >
                              Logout
                            </Link>
                          </li>
                        </ul>
                      </li>
                    )}
                    <li>
                      <Link
                        to={isLoggedIn ? routes.trackOrder : routes.login}
                        onClick={() =>
                          !isLoggedIn && toast.warning('Please Login to Tract Order')
                        }
                        title="Track Order"
                      >
                        <TbMapPin size={22} />
                      </Link>
                    </li>
                    <li className="cart__menu position-relative">
                      <Link
                        to={isLoggedIn ? routes.customerDashboard : routes.login}
                        onClick={() => {
                          if (isLoggedIn) {
                            dispatch(setActiveCustomerTab('wishlist'));
                          } else {
                            toast.warning('Please Login to Wishlist');
                            navigate(routes.login);
                          }
                        }}
                        title="Wishlist"
                      >
                        <TbHeart size={22} />
                      </Link>
      
                      <span className="badge badge-light cart_qty position-absolute start-100 translate-middle">
                        {isLoggedIn ? dataCount : 0}
                      </span>
                    </li>
                    <li className="cart__menu position-relative">
                      <button
                        className="border-0 bg-transparent"
                        onClick={() => {
                          setVisibleRight(true);
                        }}
                      >
                        {/* <button type='button'></button> */}
                        <TbShoppingCart size={22} title="Cart" />
                        <span className="badge badge-light cart_qty position-absolute start-100 translate-middle">
                          {cartItems?.length}
                        </span>
                      </button>
                    </li>
                  </ul>
                  <Sidebar
                    visible={visibleRight}
                    position="right"
                    onHide={() => setVisibleRight(false)}
                    showCloseIcon={false}
                    className="custom-sidebar"
                  >
                    {/* Header */}
                    <div className="cart-header">
                      <div className="cart-title">My Cart</div>
                      <Button
                        icon={<MdClose size={20} />}
                        className="p-button-text p-button-rounded p-button-danger cart-close-btn"
                        onClick={() => setVisibleRight(false)}
                      />
                    </div>

                    {/* Content */}
                    {cartItems?.length > 0 ? (
                      <div className="cart-content">
                        {cartItems.map((item, index) => (
                          <div key={index} className="cart-item">
                            <div className="cart-item-details">
                              <div className="cart-description">
                                <div className="cart-image">
                                  <img
                                    src={item?.image}
                                    alt={item?.name}
                                    className="img-fluid"
                                  />
                                </div>
                                <div className="cart-info-details">
                                  <div className="cart-title">
                                    <p>{item?.name}</p>
                                  </div>
                                  <div className="quantity">
                                    <p>
                                      <span className="text-muted">
                                        {item.variant && `(${item.variant}) `}
                                      </span>
                                      {item?.quantity} x {item?.price}
                                    </p>
                                  </div>
                                </div>
                              </div>

                              <div className="cart-remove">
                                <button
                                  onClick={() => dispatch(removeCartItem(item?.id))}
                                >
                                  <MdDelete size={20} color="red" />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="empty-cart-content">
                        <img
                          src={emptycart}
                          alt="Empty Cart"
                          className="empty-cart-image"
                        />
                        <p className="empty-cart-text">
                          Your cart is currently empty
                        </p>
                        <Link to={routes?.home} className="shop-now-btn">
                          Shop Now
                        </Link>
                      </div>
                    )}

                    {/* Footer */}
                    <div className="cart-footer">
                      <span>Subtotal:</span>
                      <span className="subtotal-amount">{total.toFixed(2)}</span>
                    </div>
                    <div className="cart-footer-btns d-flex ">
                      <Link
                        to={routes.cart}
                        className="btn btn-primary w-100 m-2"
                        onClick={() => setVisibleRight(false)}
                      >
                        View Cart
                      </Link>
                      <button
                        className="btn btn-secondary w-100 m-2"
                        onClick={handleCheckout}
                      >
                        Checkout
                      </button>
                    </div>
                  </Sidebar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <nav
        id="sidebar"
        className="mCustomScrollbar _mCS_1 mCS-autoHide mCS_no_scrollbar"
        style={{ overflow: "visible" }}
      >
        <div
          id="mCSB_1"
          className="mCustomScrollBox mCS-minimal mCSB_vertical mCSB_outside"
          style={{ maxHeight: "480px" }}
        >
          <div
            id="mCSB_1_container"
            className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
            style={{ position: "relative", top: "0px", left: "0px" }}
            dir="ltr"
          >
            <div id="dismiss" onClick={sidebarClose}>
              <i className="fa fa-arrow-left"></i>
            </div>
            <div className="sidebar-header"></div>
            <ul className="list-unstyled components">
              {headerData.headers.map((header: any) => (
                <li key={header.id}>
                  <Link
                    to={`${header?.slug == '#' ? '#' : routePrefix + '/' + header?.slug}`}
                  >
                    {header?.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div
          id="mCSB_1_scrollbar_vertical"
          className="mCSB_scrollTools mCSB_1_scrollbar mCS-minimal mCSB_scrollTools_vertical"
          style={{ display: "none" }}
        >
          <div className="mCSB_draggerContainer">
            <div
              id="mCSB_1_dragger_vertical"
              className="mCSB_dragger"
              style={{
                position: "absolute",
                minHeight: "0px",
                height: "0px",
                top: "0px",
                display: "block",
              }}
            >
              <div
                className="mCSB_dragger_bar"
                style={{ lineHeight: "0px" }}
              ></div>
            </div>
            <div className="mCSB_draggerRail"></div>
          </div>
        </div>
      </nav>
      <div id="overlay" onClick={sidebarClose}></div>
    </>
  );
};

export default Header3;
